var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('div',{staticClass:"titel"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_c('div',{style:({
    width: '100%',
    height: '140px',
    border: '1px solid #f4f4f4',
  }),attrs:{"id":_vm.title}})])])}
var staticRenderFns = []

export { render, staticRenderFns }